var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"worldMap"},[_c('div',{ref:"worldMap",attrs:{"id":"main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }